import { Application } from '../../../../../types/api';
import { COMPANY_TYPES } from '../../constants';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { LoanApplication } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { leaseOfTheSystemProperty } =
  loanFormModel.formField.solarSystemDocuments;
const {
  systemPropertyOwnershipStatus,
  forProfitCompanyType,
  nonProfitOrganizationType,
  industryBorrowerReported,
} = loanFormModel.formField;

export class LeaseOfTheSystemPropertyValidation implements ValidationSchema {
  public name = leaseOfTheSystemProperty.name;
  public label = '';
  public dependsOn: string[] = [
    systemPropertyOwnershipStatus.name,
    forProfitCompanyType.name,
    nonProfitOrganizationType.name,
    industryBorrowerReported.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public when(
    systemPropertyOwnershipStatus: Application['sys_prop_ownership_status_picklist'],
    forProfitCompanyTypeValue: Application['for_profit_company_type'],
    nonProfitOrganizationTypeValue: Application['non_profit_organization_type'],
    industryBorrowerReportedValue: Application['industry_borrower_reported'],
    schema
  ) {
    if (
      LoanApplication.getBusinessType({
        forProfitCompanyType: forProfitCompanyTypeValue,
        nonProfitOrganizationType: nonProfitOrganizationTypeValue,
        industryBorrowerReported: industryBorrowerReportedValue,
      }) === COMPANY_TYPES.PROPERTY_COMPANY
    ) {
      return FileNameValidationSchema(
        leaseOfTheSystemProperty.name,
        false
      ).notRequired();
    }
    if (systemPropertyOwnershipStatus === 'LEASED')
      return FileNameValidationSchema(
        leaseOfTheSystemProperty.name,
        true
      ).required('This document is required');
    return FileNameValidationSchema(
      leaseOfTheSystemProperty.name,
      false
    ).notRequired();
  }
}
export default new Validation(new LeaseOfTheSystemPropertyValidation());
